__webpack_require__.p = "/goblin-surprise/";